export { reconciliationScreen } from './reconciliation.screen';
export { LEGACY_TAB_REDIRECTS, RECONCILIATION_PATH, reconciliationSearch, tabSearch } from './reconciliation.search';
export { loadReconciliationMessages } from './reconciliation.catalog';
export const loadReconciliationScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadReconciliationGuides = () => import('./reconciliation.guide');
